import {
  MAP_PREFERENCE_USER_ROLES,
  USER_PREFERENCE_ROLES_MAP,
} from "static/preferences";

export const getRolePreference = (account, featureKey, fieldKey) => {
  return account?.role_preferences?.[featureKey]?.[fieldKey];
};

export const getRolePreferenceByAccount = (
  accounts,
  accountName,
  featureKey,
  fieldKey
) => {
  return (
    accounts
      ?.find((account) => account?.name === accountName)
      ?.role_preferences?.[
        featureKey
      ]?.[fieldKey]?.map((role) => USER_PREFERENCE_ROLES_MAP[role]) || []
  );
};

export const checkRolePreference = (
  accounts,
  featureKey,
  fieldKey,
  userRole
) => {
  const mappedRole = MAP_PREFERENCE_USER_ROLES[userRole];

  return accounts?.some((account) =>
    account?.role_preferences?.[featureKey]?.[fieldKey]?.includes(mappedRole)
  );
};

export const sortObjectKeys = (obj1, obj2) => {
  // Extract keys from obj2 and sort them
  const sortedKeys = Object.keys(obj2);

  // Create a new object with sorted keys
  const sortedObj = {};

  if (obj1 && sortedKeys?.length > 0) {
    sortedKeys?.forEach((key) => {
      // Check if the key exists in obj1
      if (Object?.hasOwn(obj1, key)) {
        sortedObj[key] = obj1[key];
      }
    });
  }

  return sortedObj;
};

export const sortByReferenceArray = (array, refArray) => {
  const newArray = [...array];
  // Create a map to store the indices of elements in refArr
  const indexMap = new Map();
  refArray?.forEach((value, index) => {
    indexMap?.set(value, index);
  });

  // Sort arr based on the indices in refArr
  newArray?.sort((a, b) => {
    const indexA = indexMap?.get(a);
    const indexB = indexMap?.get(b);
    return indexA - indexB;
  });

  return newArray;
};
